import { types } from 'mobx-state-tree';
import {isValidDateRangeString} from '../../lib/formatDate';

export const dateRangeType = types.refinement("DateRangeType", types.string, value => {
    return isValidDateRangeString(value)
})